<template>
  <div id="BannerTalk">
    <div class="question" @click="goList" v-if="question">
      <div class="left">
        <div class="profile">
          <img
            class="b-img"
            :src="
              (question.user.image || question.user.image_kakao) | image
            "
            v-if="
              question &&
              question.user &&
              !question.user.category &&
              (question.user.image || question.user.image_kakao)
            "
          />
          <img
            class="b-img"
            src="@/assets/images/pirate/profile.svg"
            v-else
          />
        </div>
      </div>
      <div class="right">
        <div
          class="content"
          v-line-clamp="2"
          v-html="question.content"
        ></div>
      </div>
    </div>
    <ProfileLoader v-else/>
  </div>
</template>

<script>
import talksApi from '@/api/now/talksApi'

import ProfileLoader from '../ProfileLoader'

export default {
  name: 'BannerTalk',
  components: {
    ProfileLoader
  },
  data() {
    return {
      question: null
    }
  },
  async created() {
    let { data } = await talksApi.getFixedQuestion()
    this.question = data.results[0]
  },
  methods: {
    goList() {
      this.$router.push({ name: 'talks' })
    }
  },
}
</script>

<style lang="scss" scoped>
#BannerTalk {
  width: 100%;
  box-sizing: border-box;
  float: left;

  .left {
    width: 40px;
    float: left;
    margin-right: 10px;
  }
  .right {
    width: calc(100% - 50px);
    float: left;
  }
  .question {
    width: 100%;
    position: relative;
    display: block;
    float: left;
    .profile {
      img {
        width: 100%;
        height: 40px;
        border-radius: 100%;
        border-width: 0;
        background-color: #f6f6f6;
      }
    }
    .content {
      font-weight: 900;
      line-height: 1.4;
      @media screen and (max-width: 350px) {
        font-size: 13px;
      }
      @media screen and (min-width: 350px) {
        font-size: 15px;
      }
    }
  }
}
</style>
